"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackEventToSegment = void 0;
const context_to_options_1 = require("./context-to-options");
const event_transformation_1 = require("./event-transformation");
async function trackEventToSegment(segment, event, transformLegacyEventForSegment) {
    const segmentAnalyticsCall = (0, event_transformation_1.transformEventForSegment)(event, transformLegacyEventForSegment);
    if (!segmentAnalyticsCall) {
        return null;
    }
    const { method, parameters } = segmentAnalyticsCall;
    switch (method) {
        case 'identify':
            return segment.identify(...parameters);
        case 'reset':
            return segment.reset();
        case 'track': {
            const [eventName, properties, ctx] = parameters;
            return segment.track(eventName, properties, (0, context_to_options_1.contextToOptions)(ctx));
        }
        default: {
            const _exhaustive = method;
            return _exhaustive;
        }
    }
}
exports.trackEventToSegment = trackEventToSegment;
//# sourceMappingURL=track-event.js.map